import type { states } from './states';

type StateName = keyof typeof states;

const usTimezoneStateGroups: Record<string, StateName[]> = {
  'All Central Timezone': [
    'Alabama',
    'Arkansas',
    'Illinois',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Nebraska',
    'North Dakota',
    'Oklahoma',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Wisconsin',
  ],
  'All Eastern Timezone': [
    'Connecticut',
    'Delaware',
    'Florida',
    'Georgia',
    'Indiana',
    'Kentucky',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'New Hampshire',
    'New Jersey',
    'New York',
    'North Carolina',
    'Ohio',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'Tennessee',
    'Vermont',
    'Virginia',
    'West Virginia',
  ],
  'All Mountain Timezone': [
    'Arizona',
    'Colorado',
    'Idaho',
    'Kansas',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Mexico',
    'North Dakota',
    'Oregon',
    'South Dakota',
    'Texas',
    'Utah',
    'Wyoming',
  ],
  'All Pacific Timezone': [
    'Arizona',
    'California',
    'Idaho',
    'Nevada',
    'Oregon',
    'Washington',
  ],
};

const australiaStatesAndTerritories = [
  'Australian Capital Territory',
  'New South Wales',
  'Northern Territory',
  'Queensland',
  'South Australia',
  'Tasmania',
  'Victoria',
  'Western Australia',
] as const;

const canadaProvincesAndTerritories = [
  'Alberta',
  'British Columbia',
  'Manitoba',
  'New Brunswick',
  'Newfoundland and Labrador',
  'Northwest Territories',
  'Nova Scotia',
  'Nunavut',
  'Ontario',
  'Prince Edward Island',
  'Quebec',
  'Saskatchewan',
  'Yukon',
] as const;

export const AddressStateConst = {
  usTimezoneStateGroups,
  australiaStatesAndTerritories,
  canadaProvincesAndTerritories,
};
